import { render, staticRenderFns } from "./form_subcategories_component.vue?vue&type=template&id=44ef9218&scoped=true"
import script from "./form_subcategories_component.vue?vue&type=script&lang=js"
export * from "./form_subcategories_component.vue?vue&type=script&lang=js"
import style0 from "./form_subcategories_component.vue?vue&type=style&index=0&id=44ef9218&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ef9218",
  null
  
)

export default component.exports